import { useEffect } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useMediaQuery } from 'react-responsive'
import { SCREEN_CHANGES } from '@disco/constants/ActionTypes'

const MobileBreakpoints = (): null => {
  const dispatch = useDispatch()
  const sm = useMediaQuery({
    maxWidth: 600,
  })
  const md = useMediaQuery({
    minWidth: 601,
    maxWidth: 1099,
  })
  const lg = useMediaQuery({
    minWidth: 1100,
  })
  useEffect(() => {
    dispatch({
      type: SCREEN_CHANGES,
      screen: {
        sm,
        md,
        lg,
      },
    })
  }, [sm, md, lg])
  return null
}

export default MobileBreakpoints
